import React, { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { ChevronDown, Search, Check } from "lucide-react";

/* Compact multi-select of vendors: shows a count + first names, opens a checklist. */
export const VendorPicker = ({ vendors, selected, onChange, disabled, testid, dim }) => {
  const [q, setQ] = useState("");
  const sel = new Set(selected || []);
  const chosen = vendors.filter((v) => sel.has(v.id));
  const list = vendors.filter((v) => !q || v.name.toLowerCase().includes(q.toLowerCase()));
  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); onChange([...n]); };
  const summary = chosen.length === 0 ? "— κανένας —" : chosen.length <= 2 ? chosen.map((v) => v.name).join(", ") : `${chosen.slice(0, 1).map((v) => v.name).join("")} +${chosen.length - 1}`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} disabled={disabled} onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center gap-1 w-full max-w-[230px] rounded-md border px-2 py-1 text-[11px] text-left transition-colors disabled:opacity-50 ${chosen.length ? "border-[#C86235]/50 bg-[#FDF6F1] text-[#45423C]" : "border-[#E3DED4] bg-white text-[#9A948A]"} ${dim ? "opacity-60" : ""} hover:border-[#C86235]`}>
          {chosen.length > 0 && <span className="shrink-0 rounded-full bg-[#C86235] text-white text-[10px] font-bold px-1.5 leading-4">{chosen.length}</span>}
          <span className="truncate" title={chosen.map((v) => v.name).join(", ")}>{summary}</span>
          <ChevronDown className="h-3.5 w-3.5 shrink-0 text-[#9A948A]" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 p-2" onClick={(e) => e.stopPropagation()} data-testid={`${testid}-menu`}>
        <div className="relative mb-1.5">
          <Search className="h-3.5 w-3.5 absolute left-2 top-2 text-[#9A948A]" />
          <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Προμηθευτής…" className="w-full rounded-lg border border-[#E3DED4] pl-7 pr-2 py-1.5 text-xs outline-none focus:border-[#45423C]" />
        </div>
        <div className="max-h-60 overflow-y-auto -mx-1 px-1">
          {list.map((v) => (
            <label key={v.id} data-testid={`${testid}-opt-${v.id}`} className="flex items-center gap-2 rounded-lg px-2 py-1.5 text-xs hover:bg-[#FAF8F4] cursor-pointer">
              <span className={`h-4 w-4 rounded border inline-flex items-center justify-center ${sel.has(v.id) ? "bg-[#C86235] border-[#C86235] text-white" : "border-[#D8D0C2] bg-white"}`}>{sel.has(v.id) && <Check className="h-3 w-3" />}</span>
              <input type="checkbox" className="hidden" checked={sel.has(v.id)} onChange={() => toggle(v.id)} />
              <span className="truncate">{v.name}</span>
            </label>
          ))}
          {list.length === 0 && <div className="px-2 py-3 text-xs text-[#9A948A]">{vendors.length ? "Κανένα αποτέλεσμα" : "Προσθέστε προμηθευτές"}</div>}
        </div>
        {chosen.length > 0 && <button data-testid={`${testid}-clear`} onClick={() => onChange([])} className="mt-1.5 w-full text-[11px] text-[#6F6A60] hover:underline">Καθαρισμός</button>}
      </PopoverContent>
    </Popover>
  );
};
